var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutfitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28.13 23.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m26.3,0h-.71l.71,4.16-1.84,3.46s-1.76-.85-2.68-3.81l-.78.14.42,3.53,1.98,2.4-1.91,1.84s-.02.01-.06.03v-2.23l-.2-.22c-.09-.09-2.18-2.27-6.82-2.27s-7.41,2.17-7.53,2.26l-.29.23v2.16l-1.86-1.79,1.98-2.4.42-3.53-.78-.14c-.92,2.96-2.68,3.81-2.68,3.81l-1.84-3.46L2.54,0h-.71L0,3.95l3.67,8.68s6,3.39,7.41,3.88c1.41.49,1.91-1.41,1.2-1.84-.46-.27-2.67-1.43-4.19-2.21v-2.19c.78-.49,3.06-1.74,6.32-1.74s4.97,1.15,5.53,1.61v2.38c-1.51.78-3.64,1.89-4.08,2.16-.71.42-.21,2.33,1.2,1.84,1.41-.49,7.41-3.88,7.41-3.88l3.67-8.68-1.84-3.95Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "19.84 18.85 16.09 22.02 12.28 22.09 8.19 18.92 8.12 16.6 6.78 15.67 6.78 19.55 11.65 23.44 16.73 23.44 21.46 19.55 21.46 15.67 19.84 16.6 19.84 18.85"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutfitter);
export default __webpack_public_path__ + "static/media/outfitter.65239ab4b25a93ce0bfda96cfba36c55.svg";
export { ForwardRef as ReactComponent };